import { createRouter, createWebHistory } from 'vue-router';
import type { Middleware, MiddlewareContext } from '@/types/router';
import type { RouteRecordRaw } from 'vue-router';

import middlewarePipeline from '@/middleware/middlewarePipeline';

import home from './home';
import livestream from './livestream';

const arr_routes = [home, livestream];

const routes: RouteRecordRaw[] = arr_routes.flat(1);

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes,
    scrollBehavior() {
        return { top: 0 };
    }
});

router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? `${to.meta.title} · Sahabat Ngaji` : 'Sahabat Ngaji';

    const middlewares = to.meta.middleware as Middleware[] | undefined;

    if (!middlewares || !middlewares.length) return next();

    const context: MiddlewareContext = { to, from, next };

    return middlewares[0]!({
        ...context,
        next: middlewarePipeline(context, middlewares, 1)
    });
});

export default router;
